export default "__VITE_ASSET__7e13dfef__"